module.exports = __webpack_public_path__ + "img/20190619163530554.8cc55242.png";